import SchemeServicingManager from '@/scheme-servicing-manager'

/**
 * Imports the scheme dynamically according to the host map.
 *
 * @export Function The plugin.
 * @returns The plugin.
 */
export default async function plugin() {
    const scheme = await SchemeServicingManager.createSchemeAsync()

    return function install(Vue) {

        /**
         * @type {Scheme} The dynamically async loaded presentation scheme for the Plan Builder.
         */
        Object.defineProperty(Vue.prototype, '$scheme', {
            get() {
                return scheme
            },
        })
    }
}
